import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import updateLocale from 'dayjs/plugin/updateLocale';
import zhTW from 'dayjs/locale/zh-tw';

require('dayjs/locale/en');
require('dayjs/locale/es');
require('dayjs/locale/zh-cn');
require('dayjs/locale/zh-tw');
require('dayjs/locale/ko');
require('dayjs/locale/ja');
require('dayjs/locale/vi');
require('dayjs/locale/pt');
require('dayjs/locale/th');

dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(updateLocale);

dayjs.updateLocale('zh-tw', {
  ...zhTW,
  meridiem: (hour, minute) => {
    const hm = hour * 100 + minute;
    if (hm < 600) {
      return '凌晨';
    } else if (hm < 900) {
      return '早上';
    } else if (hm < 1100) {
      return '上午';
    } else if (hm < 1300) {
      return '中午';
    } else if (hm < 1800) {
      return '下午';
    }
    return '晚上';
  }
});

export default dayjs;
